//=require _jquery.fancybox.min.js

$.fancybox.defaults.loop = true;
